<template>
  <LayoutDefault>
    <div
        v-if="model && model.webstar"
        id="webstar_profile"
        class="container"
    >
      <div
          class="banner"
          :style="{backgroundImage: `url('${model.public_banner_image_path}')`}"
      >
      </div>
      <div class="data">
        <div class="profile">
          <div class="pic"
               :style="{backgroundImage: `url('${model.public_profile_image_path}')`}"
          ></div>
          <div class="name">
            {{model.name}}
            <div
                v-if="model.username"
                class="username"
            >
              @{{ model.username }}
              <img
                v-if="model.verified"
                class="badge-verified"
                src="/img/verified.png"
                alt="verified"
                title="verified"
              >
            </div>
          </div>
        </div>
        <div class="right-container">
          <div class="subscribe-actions" style="display: flex; flex-direction: column;">
            <ButtonChatWithModel
              class="btn_follow"
              :subscription_plan="subscriptionPlanPremium"
              :model="model"
            />
            <div
              v-if="model.subscription_plans"
            >
              <FollowModelButton
                  v-if="model.webstar && model.following !== 'premium'"
                  class="btn_follow"
                  v-for="subscription_plan in model.subscription_plans.data"
                  :key="subscription_plan.id"
                  :subscription_plan="subscription_plan"
              />
            </div>
          </div>
          <div class="about-me">
            {{ model.about_me }}
            
            <div
              v-for="(social, index ) in model.public_socials"
              :key="index"
              class="social-buttons"
            >
              <a :href="social.url" target="_blank">
                <img :src="`/img/socials/${social.site}.png`" :alt="social.site">
                @{{social.user}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
        id="model_profile"
        class="container"
    >
      <template v-if="!loadingModel && !errorModel">
        <div class="model-wrapper">
          <h3
              v-if="!model.webstar"
              class="title">
              {{model.name}}
          </h3>

          <div class="video-wrapper"></div>

          <div class="model-video-list">
<!--            <h4 class="title">-->
<!--              {{$t('model_profile.videos_im_in')}}-->
<!--            </h4>-->
            <ResourceScroller
                    :v-if="modelMoviesScroller !== null"
                    :resource="modelMoviesScroller.resource"
                    :default-params="modelMoviesScroller.defaultParams"
                    :per-page="2"
            >
              <template slot-scope="{element}">
                <PostSorter :element="element" :model="model"/>
              </template>
              <template slot="placeholder" slot-scope="data">
                <MovieBlockedContainer :placeholder="true"/>
              </template>
            </ResourceScroller>
          </div>
        </div>
      </template>

      <template v-else>
        <div v-if="loadingModel" class="loading-model">
          <Spinner></Spinner>
        </div>
        <div v-if="errorModel" class="error-model">
            {{$t('error')}}
        </div>
      </template>
    </div>
  </LayoutDefault>
</template>

<script>
import Spinner from "../../components/Spinner";
import resources from '../../resources';
import ResourceScroller from "../../components/V2/ResourceScroller";
import MovieBlockedContainer from "../../components/V2/PostContainer/MovieBlockedContainer";
import EventBus from '../../eventbus';
import LayoutDefault from "../../layouts/LayoutDefault";
import FollowModelButton from "../../components/CallToAction/ButtonFollowModel";
import ButtonChatWithModel from "../../components/CallToAction/ButtonChatWithModel";
import PostSorter from "../../components/V2/PostSorter/PostSorter";

export default {
    components: {
      PostSorter,
        LayoutDefault,
        Spinner,
        ResourceScroller,
        MovieBlockedContainer,
        FollowModelButton,
        ButtonChatWithModel
    },
    data(){
      return {
          model: null,
          loadingModel: true,
          errorModel: false,
      }
    },
    methods: {
        loadModel(id){
            this.loadingModel = true;
            this.errorModel = false;
            this.model = null;

            let data = { id: id };
            if(this.$route.params.username){
              data.username = id;
            }
            
            if(this.$i18n && this.$i18n.locale){
              data.lang = this.$i18n.locale;
            }
  
          data.include = ['subscription_plans'];
            
            resources.models.get(data)
                .then(response => {
                    if(response.data.data.length === 0){
                      this.$router.push({name: 'home'});
                    }
                    this.loadingModel = false;
                    this.model = response.data.data;
                }).catch(err => {
                    this.loadingModel = false;
                    this.errorModel = true;
                });
        },
    },
    mounted(){
        let model = (this.$route.params.username) ? this.$route.params.username : this.$route.params.id;
        this.loadModel(model);

        EventBus.$on('languageChanged', () => {
            this.loadModel(model);
        });
    },
    beforeRouteUpdate (to, from, next) {
        this.loadModel(to.params.id);

        next();
    },
    computed: {
        similarModelsScroller(){
            if(this.loadingModel || this.errorModel){
                return null;
            }

            return {
                resource: resources.models,
                defaultParams: {
                    include: [],
                    models: {
                        id: this.model.id
                    }
                },
            };
        },
        modelMoviesScroller(){
            if(this.loadingModel || this.errorModel){
                return null;
            }

            return {
                resource: resources.posts,
                defaultParams: {
                    include: [],
                    models: {
                        id: this.model.id
                    }
                },
            };
        },
        subscriptionPlanPremium(){
            if(this.loadingModel || this.errorModel || !this.model.subscription_plans){
                return null;
            }

            return this.model.subscription_plans.data.find(subscription_plan => subscription_plan.premium)
        },
    },
  }
</script>

<style scoped lang="scss">
  @import '../../styles/variables';

  #model_profile{
    background-color: $pallete_clear_color;
    padding: 30px 7px;

    .model-wrapper{
      display: block;
      margin: auto;
      max-width: 100%;

      .about{
        display: block;
        margin: auto;
        width: 70%;

        @media(max-width: 768px){
          width: 100%;
        }
      }

      & > .title {
          border-top: 10px solid $pallete_main_color;
          color: #000000;
          padding: .33em;
          font-size: 1.4em;
          text-align: left;
          margin: 0;
          text-transform: uppercase;
          display: inline-block;
      }

      .image{
        /*
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
            background-color: lightgrey;
        */

        min-height: 250px;
        max-width: 100%;
        height: auto;

        img{
            width: auto;
            display: block;
            margin: auto;
            height: auto;
            max-height: 100vh;
        }
      }

      .title{
        text-align: left;
        margin: 0;
        margin-bottom: 10px;
      }

      .banner{
        display: block;
        margin: auto;
        width: auto;
        max-height: 500px;
      }

      .details{
        .title{
          font-size: 40px;
          text-transform: uppercase;
          color: $pallete_main_color;
          margin: 0 0 20px 0;
        }
      }

    }

    .model-video-list{
      margin-bottom: 75px;
      margin-top: 35px;

      .title{
        font-size: 1.4em;
        text-align: left;
        margin: 5px;
        margin-bottom: 15px;
        text-transform: uppercase;
      }
    }

    .related-models{

      .title{
        font-size: 1.4em;
        text-align: left;
        margin: 5px;
        margin-bottom: 15px;
        text-transform: uppercase;
      }


    }
  }
</style>
<style lang="scss">
  #model_profile{
    .related-models {
      .model {
        width: 250px;

        .img {
          height: 420px;
        }
      }
    }

    // tamaño del video
    .model-video-list{
    }
  }
</style>

<style scoped lang="scss">
#webstar_profile {
  .banner{
    position: relative;
    height: 350px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    @media(max-width: 768px){
      height: 200px;
    }
  }

  .data{
    position: relative;
    height: 150px;
    background: #f1f2f6;
    @media(max-width: 768px){
      height: unset;
    }

    .profile{
      width: 40%;
      min-height: 250px;
      position: absolute;
      left: 5px;
      top: -100px;
      @media(max-width: 768px){
        position: relative;
        width: 100%;
        min-height: unset;
      }
      .pic{
        width: 200px;
        height: 200px;
        margin: 0 auto;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        background-color: #ffffff;
        border-radius: 50%;
        border: 3px solid #ffffff;

        @media(max-width: 768px){
          width: 150px;
          height: 150px;
        }
      }
      .name{
        min-height: 50px;
        font-size: 1.5em;
        font-weight: bold;
        text-align: center;
        text-transform: uppercase;
        margin: 10px;
        @media(max-width: 768px){
          min-height: unset;
        }

        .username{
          display: flex;
          justify-content: center;
          font-size: .6em;
          text-transform: initial;
          margin: 3px;
          color: #7986cb;
          &:hover{
            color: #5768c4;
          }
          
          img{
            &.badge-verified{
            width: 20px;
            margin-left: 5px;
            }
          }
        }
      }
    }

    .right-container{
      position: absolute;
      display: flex;
      right: 10px;

      top: 10px;
      width: 65%;
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: flex-start;

      .btn_follow{}

      .about-me{
        margin-right: 20px;
        @media(max-width: 768px){
          margin: 10px auto 25px auto;
        }
  
        .social-buttons{
          margin: 10px 0;
          
          a{
            display: flex;
            align-items: center;
            font-size: .8em;
  
            @media(max-width: 768px){
              justify-content: center;
            }
            
            img{
              width: 20px;
              margin-right: 5px;
            }
          }
        }
      }

      @media(max-width: 768px){
        position: relative;
        width: 95%;
        text-align: center;
        right: 0;
        left: 0;
        top: unset;
        bottom: 0;
        margin: 0 auto;
        flex-direction: column-reverse;
        align-items: center;
        margin-top: -100px;
      }
    }
  }
}
</style>
